import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/dispatching",
		component: lazy(() => import("./CarriersAdvancedDashboardPage")),
	},
]);
